import { RequestDataSuccess } from '../../../RequestAction';
import { BookVersioning } from '@Models';

export class RequestBookVersioningSuccess extends RequestDataSuccess<
  Array<BookVersioning>
> {
  constructor({ payload }: { payload: Array<BookVersioning> }) {
    super({ payload: payload });
  }
}
